// Lokales transparentes PNG (Hintergrund entfernt) — Mai 2026.
// v6 = Brain-Only-Logo wiederhergestellt für Top-Nav/Footer/Legal-Pages.
// Cache-Buster (?v=6) erzwingt Reload beim nächsten Visit.
export const LOGO_URL = "/Logo-alphalane-ai.png?v=6";

// Hero/Live-Status verwendet die KOMBINIERTE Logo-Variante (Brain + "ALPHALANE AI").
// Identisch zur Marketing-Materialien-Download-Datei (/Logo.png).
export const LOGO_HERO_URL = "/Logo.png?v=5";

export const CONTACT_EMAIL = "pascal@moonshine-solutions.com";
